import { TriangleAlert } from 'lucide-react';
import { Badge } from '@/components/ui/Badge';
import { fmtDob } from './clientHelpers';
import type { AuthExpiryWarning } from './clientHelpers';

export function AuthExpiryIndicator({
    warning,
    className,
}: {
    warning: AuthExpiryWarning | null;
    className?: string;
}) {
    if (!warning) return null;
    const variant = warning.kind === 'Expired' ? 'error' : 'warning';
    const when = fmtDob(warning.end);
    const label = warning.kind === 'Expired'
        ? `Auth Expired on ${when}`
        : `Auth Expires on ${when}`;
    return (
        <Badge
            variant={variant}
            className={className}
            role="img"
            aria-label={label}
            title={label}
        >
            <TriangleAlert className="w-3 h-3" aria-hidden />
        </Badge>
    );
}
